import styled, { css } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';
import { spacing } from '../constants/spacing.js';
import { boxStyles } from '../Box/styles.js';
import { fontFamilyStyles } from '../ContentText/styles.web.js';
var select =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "styles__select",
  componentId: "whb10e-0"
})(["position:relative;width:100%;", " ", ""], function (props) {
  return props.opened && css(["z-index:20;"]);
}, boxStyles);
var icons =
/*#__PURE__*/
styled.span.withConfig({
  displayName: "styles__icons",
  componentId: "whb10e-1"
})([".fill{fill:", ";transition:fill ", ";transition-timing-function:", ";}span{position:absolute;right:", ";top:", ";transition-timing-function:", ";z-index:6;&:first-child{transition:transform ", ",opacity ", ";transition-delay:", ";}&:last-child{opacity:0;transition:transform ", ",opacity ", ";transform:rotate(180deg) translateY(", ");transition-delay:0;}}"], function (p) {
  return p.theme.select.web.inactive;
}, styles.transition.timing.slower, styles.transition["function"].base, spacing.xxs, px2rem(20), styles.transition["function"].base, styles.transition.timing.slower, styles.transition.timing.slower, styles.transition.timing.extraFast, styles.transition.timing.fastest, styles.transition.timing.fastest, px2rem(-5));
var label =
/*#__PURE__*/
styled.span.withConfig({
  displayName: "styles__label",
  componentId: "whb10e-2"
})(["", " color:", ";font-size:", ";font-weight:", ";left:0;overflow:hidden;padding:0 ", ";padding-left:", ";pointer-events:none;position:absolute;right:0;text-overflow:ellipsis;top:", ";transition:color ", ",padding-left ", ";transition-timing-function:", ";z-index:5;white-space:nowrap;"], fontFamilyStyles, function (props) {
  return props.opened ? props.color : props.theme.select.web.label.color;
}, px2rem(12), function (props) {
  return props.theme.select.web.label.fontWeight;
}, spacing.xxs, function (props) {
  return props.readOnly ? 0 : spacing.xxs;
}, px2rem(13), styles.transition.timing.slower, styles.transition.timing.slower, styles.transition["function"].base);
var selectHeading =
/*#__PURE__*/
styled.button.withConfig({
  displayName: "styles__selectHeading",
  componentId: "whb10e-3"
})(["", " border:none;outline:none;::-moz-focus-inner{border:none;}box-sizing:border-box;text-align:left;background:", ";", " ", "       color:", ";display:block;font-size:", ";height:", ";overflow:hidden;padding:", " ", " ", " ", ";padding-left:", ";position:relative;text-overflow:ellipsis;", " ", " ", " transition-timing-function:", ";width:100%;white-space:nowrap;z-index:4;", " ", "{", " span{&:first-child{", "}&:last-child{", "}}}"], fontFamilyStyles, function (props) {
  return props.readOnly ? 'transparent' : props.disabledStyles ? props.theme.select.web.disabled.background : props.theme.select.web.background;
}, function (props) {
  return props.readOnly ? css(["border:", " solid transparent;"], px2rem(2)) : props.borderStyle === 'full' ? css(["border:", " solid ", ";"], px2rem(2), props.error ? props.theme.select.web.error : props.opened ? props.color : props.theme.select.web.inactive) : css(["border-bottom:", " solid ", ";"], px2rem(2), props.error ? props.theme.select.web.error : props.opened ? props.color : props.theme.select.web.inactive);
}, function (props) {
  return !props.readOnly && props.disabledStyles && css(["cursor:", ";"], props.disabledStyles ? 'not-allowed' : 'pointer');
}, function (props) {
  return props.disabledStyles ? props.theme.select.web.disabled.label : props.theme.select.web.textColor;
}, px2rem(18), px2rem(64), px2rem(28), spacing.m, px2rem(12), px2rem(14), function (props) {
  return props.readOnly ? 0 : px2rem(14);
}, function (props) {
  if (props.borderRadius) {
    return css(["border-top-left-radius:", ";border-top-right-radius:", ";"], px2rem(props.borderRadius), px2rem(props.borderRadius));
  }
}, function (props) {
  if (props.borderRadius && !props.opened) {
    return css(["border-bottom-left-radius:", ";border-bottom-right-radius:", ";"], px2rem(props.borderRadius), px2rem(props.borderRadius));
  }
}, function (props) {
  return props.readOnly === undefined ? css(["transition:background ", ",border-color ", ";"], styles.transition.timing.slower, styles.transition.timing.slowest) : css(["transition:background ", ",padding-left ", ",border-color ", " ", ";"], props.readOnly ? '0s' : '0s', styles.transition.timing.slower, styles.transition.timing.slowest, props.readOnly ? '0s' : styles.transition.timing.faster);
}, styles.transition["function"].base, function (props) {
  return !props.disabledStyles && !props.readOnly && css(["&:hover,&:focus{border-color:", ";", "{.fill{fill:", ";}}}"], function (props) {
    return props.color;
  }, icons, function (props) {
    return props.color;
  });
}, icons, function (props) {
  return props.opened && css([".fill{fill:", ";}"], function (props) {
    return props.color;
  });
}, function (props) {
  return props.opened && css(["opacity:0;transform:translateY(", ");transition:transform ", ",opacity ", ";transition-delay:0;"], px2rem(5), styles.transition.timing.fastest, styles.transition.timing.fastest);
}, function (props) {
  return props.opened && css(["opacity:1;transform:translateY(0) rotate(180deg);transition:transform ", ",opacity ", ";transition-delay:", ";"], styles.transition.timing.slower, styles.transition.timing.slower, styles.transition.timing.extraFast);
});
export { icons, label, select, selectHeading };